const initialState = {
    userInfo: {
        userId: "",
        userRole: ""
    },
    tipForm: {

    }
};
const reducer = (state = initialState, action) => {

    switch (action.type) {
        case "SAVE_LOGIN_USER": {
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    userId: action.value.userName,
                    userRole: action.value.userRole
                }
            };
        }
        case "SAVE_TIP_FORM": {
            return {
                ...state,
                tipForm:action.value
            };
        }
        default: { 
            console.log();
        }
    }

    return state;
};

export default reducer;